export default function Services() {
  const services = [
    {
      icon: 'ri-shopping-cart-line',
      title: 'Catalogo Esteso',
      description:
        'Oltre 5000 referenze tecnologiche sempre disponibili per soddisfare ogni esigenza del tuo business',
      color: 'orange',
      bgColor: 'from-orange-50 to-orange-100',
    },
    {
      icon: 'ri-truck-line',
      title: 'Spedizioni Rapide',
      description:
        'Consegna garantita in 24/48h su tutto il territorio nazionale con tracking completo',
      color: 'blue',
      bgColor: 'from-blue-50 to-blue-100',
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Supporto Dedicato',
      description:
        'Team commerciale specializzato sempre a tua disposizione per consulenza e assistenza',
      color: 'green',
      bgColor: 'from-green-50 to-green-100',
    },
  ];

  return (
    <section id="servizi" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12 mb-16">
          <div>
            <h2 className="text-5xl font-black text-gray-900 leading-tight">
              Perché Scegliere
              <span className="block text-orange-500">Word Art</span>
            </h2>
          </div>
          <div className="flex items-end">
            <p className="text-lg text-gray-600 leading-relaxed">
              Offriamo soluzioni complete per la distribuzione tecnologica con
              servizi professionali pensati per il successo del tuo business
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className={`bg-gradient-to-br ${service.bgColor} rounded-3xl p-10 hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer`}
            >
              <div
                className={`w-16 h-16 flex items-center justify-center bg-${service.color}-500 rounded-2xl mb-6 shadow-lg`}
              >
                <i className={`${service.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {service.title}
              </h3>
              <p className="text-gray-700 leading-relaxed text-base">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
